import axios from 'axios';
import { Env } from '@/configuration';
import { Team } from './models';

const fetchTeams = async (seasonId?: number) => {
  const teamsUrl = Env.AdminApiOptions.endpointUrl(seasonId ? `teams/${seasonId}` : 'teams');
  const response = await axios.get(teamsUrl);
  const result: Team[] = response && response.data;
  return result;
};

export default {
  fetchTeams,
};
